/**
 * 班课api
 * 班课相关界面api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import StatisticsItemVo from './StatisticsItemVo';




  /**
   * The GroupedStatisticsVo model module.
   * @module clazz_course/model/GroupedStatisticsVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>GroupedStatisticsVo</code>.
   * @alias module:clazz_course/model/GroupedStatisticsVo
   * @class
   */
  var exports = function() {
    var _this = this;





  };

  /**
   * Constructs a <code>GroupedStatisticsVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:clazz_course/model/GroupedStatisticsVo} obj Optional instance to populate.
   * @return {module:clazz_course/model/GroupedStatisticsVo} The populated <code>GroupedStatisticsVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'serialName')) {
        obj['serialName'] = ApiClient.convertToType(data['serialName'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'statistics')) {
        obj['statistics'] = ApiClient.convertToType(data['statistics'], [StatisticsItemVo]);
      }
    }
    return obj;
  }

  /**
   * id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * serial name
   * @member {String} serialName
   */
  exports.prototype['serialName'] = undefined;
  /**
   * title
   * @member {String} title
   */
  exports.prototype['title'] = undefined;
  /**
   * @member {Array.<module:clazz_course/model/StatisticsItemVo>} statistics
   */
  exports.prototype['statistics'] = undefined;



  export default exports;
;


